import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const clientTypeOf = (c) => c.client_type || ((c.company || "").trim() ? "societe" : "particulier");

// Particulier / Société + SIRET (shown only for a company)
export const ClientTypeField = ({ client, onChange, t, testid = "client", hideSiret = false }) => {
  const type = clientTypeOf(client);
  const opt = (v, label) => (
    <label className="flex items-center gap-1.5 cursor-pointer text-sm">
      <input type="radio" name={`${testid}-type`} checked={type === v} onChange={() => onChange({ client_type: v, ...(v === "particulier" ? { siret: "" } : {}) })}
        className="accent-[#9E7B41]" data-testid={`${testid}-type-${v}`} />
      {t(label)}
    </label>
  );
  return (
    <div className="flex flex-wrap items-end gap-x-5 gap-y-2 col-span-full" data-testid={`${testid}-type`}>
      <div className="flex items-center gap-4 h-10">{opt("particulier", "Particulier")}{opt("societe", "Société")}</div>
      {type === "societe" && !hideSiret && (
        <div className="w-56"><Label className="text-xs">{t("SIRET")}</Label>
          <Input value={client.siret || ""} inputMode="numeric" maxLength={17} onChange={(e) => onChange({ siret: e.target.value })} className="mt-1" data-testid={`${testid}-siret`} /></div>
      )}
    </div>
  );
};
